import(/* webpackMode: "eager" */ "/home/hyrelancer_frontend/hyrelancer/src/app/(public)/blog/[id]/page.jsx");
